module.exports = __webpack_public_path__ + "linea-ecommerce-10.e8892174d7f87530f38e.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/assets/linea/fonts/linea-ecommerce-10.ttf
// module id = ../../../../../src/assets/linea/fonts/linea-ecommerce-10.ttf
// module chunks = styles